import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent }           from './app.component';
import { LoginComponent }         from './login/login.component';
import { DashboardComponent }     from './dashboard/dashboard.component';
import { DoctorsComponent }       from './doctors/doctors.component';
import { DoctorDetailComponent }  from './doctors/detail/doctor-detail.component';
import { DoctorCallDetailComponent } from './doctors/detail/doctor-call-detail.component';
import { AdminsComponent }        from './admins/admins.component';
import { AdminDetailComponent }   from './admins/detail/admin-detail.component';
import { PatientsComponent }      from './patients/patients.component';
import { PatientDetailComponent } from './patients/detail/patient-detail.component';
import { PatientAuthDetailComponent } from './patients/detail/patient-auth-detail.component';
import { PatientCallDetailComponent } from './patients/detail/patient-call-detail/patient-call-detail.component';
import { PlansComponent }      from './plans/plans.component';
import { PlanDetailComponent } from './plans/detail/plan-detail.component';

import { MigrationsComponent } from './migrations/migrations.component';

import { HolidaysComponent }      from './holidays/holidays.component';
import { CallsComponent }      from './calls/calls.component';
import { CallDetailComponent }      from './calls/detail/call-detail.component';

import { ReportsComponent } from './reports/reports.component';
import { PrioritiesComponent } from './priorities/priorities.component'
import { AppsInfoComponent } from './appsInfo/appsInfo.component'
import { ProvidersComponent } from './providers/providers.component'
import { ProviderComponent } from './providers/provider/provider.component'
import { SpecialtyProviderConfigComponent } from './specialty-provider-config/specialty.provider.config.component'
import { ParticularsComponent } from './particular/particulars.component'

import { PharmaciesComponent } from './pharmacies/pharmacies.component'
import { LoginAttemptsComponent } from './login-attempts/login-attempts.component'

import { SellerComponent } from './seller/seller.component'
import { SellerDetailComponent } from './seller/seller-detail/seller-detail.component'

import { CreatePatientComponent } from './patients/create/create-patient.component'

import { Authorized }   from './services/activators/authorized.service';
import { NotLoggedIn }  from './services/activators/not-logged-in.service';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CreateCallComponent } from './calls/createCall.component';

import { DevelopersComponent } from './developers/developers.component';
import { DeveloperDetailComponent } from './developers/detail/developer-detail.component';
import { ProviderLogoPriorityComponent } from './provider-logo-priority/provider-logo-priority.component';
import { MedicinesComponent } from './medicines/medicines.component';
import { SpecialtiesComponent } from './specialties/specialties.component';
import { SpecialtyComponent } from './specialties/specialty/specialty.component';
import { HealthInsurancesComponent } from './health-insurances/health-insurance.component';
import { CallTagsComponent } from './callTags/call-tag.component';
import { PatientValidationComponent } from './patient-validation/patient-validation.component'
import { DoctorsStatusComponent } from './doctors/detail/doctor-status.component';
import { FailedEmailComponent } from './failed-email/failed-email.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login',       component: LoginComponent,        	canActivate: [NotLoggedIn] },
  { path: 'dashboard',   component: DashboardComponent,    	canActivate: [Authorized] },
  { path: 'admins',      component: AdminsComponent,       	canActivate: [Authorized] },
  { path: 'admin/:id',   component: AdminDetailComponent,  	canActivate: [Authorized] },
  { path: 'doctors',     component: DoctorsComponent,      	canActivate: [Authorized] },
  { path: 'doctor/:id',  component: DoctorDetailComponent, 	canActivate: [Authorized] },
  { path: 'doctor/:id/calls',  component: DoctorCallDetailComponent, 	canActivate: [Authorized] },
  { path: 'doctors/status',  component: DoctorsStatusComponent, 	canActivate: [Authorized] },
  { path: 'patients',    component: PatientsComponent,      canActivate: [Authorized] },
  { path: 'patient/:id', component: PatientDetailComponent, canActivate: [Authorized] },
  { path: 'patient/:id/auth', component: PatientAuthDetailComponent, canActivate: [Authorized] },
  { path: 'patient/:id/calls',  component: PatientCallDetailComponent, 	canActivate: [Authorized] },
  { path: 'createPatient',  component: CreatePatientComponent, 	canActivate: [Authorized] },
  { path: 'sellers',    component: SellerComponent,      canActivate: [Authorized] },
  { path: 'seller/:id', component: SellerDetailComponent, canActivate: [Authorized] },
  { path: 'plans',       component: PlansComponent, canActivate: [Authorized] },
  { path: 'plan/:id',    component: PlanDetailComponent, canActivate: [Authorized] },
  { path: 'holidays',       component: HolidaysComponent, canActivate: [Authorized] },
  { path: 'calls',       component: CallsComponent, canActivate: [Authorized] },
  { path: 'call/:id',       component: CallDetailComponent, canActivate: [Authorized] },
  { path: 'createCall',       component: CreateCallComponent, canActivate: [Authorized] },
  { path: 'reports',       component: ReportsComponent, canActivate: [Authorized] },
  { path: 'priorities',      component:PrioritiesComponent,canActivate: [Authorized] },
  { path: 'appsInfo',      component:AppsInfoComponent,canActivate: [Authorized] },
  { path: 'providers',      component:ProvidersComponent,canActivate: [Authorized] },
  { path: 'providers/:id',      component:ProviderComponent,canActivate: [Authorized] },
  { path: 'particulars',      component:ParticularsComponent,canActivate: [Authorized] },
  { path: 'migrations',      component:MigrationsComponent,canActivate: [Authorized] },
  { path: 'pharmacies',      component:PharmaciesComponent,canActivate: [Authorized] },
  { path: 'loginAttempts',      component:LoginAttemptsComponent,canActivate: [Authorized] },
  { path: 'developers',    component: DevelopersComponent,      canActivate: [Authorized] },
  { path: 'developer/:id', component: DeveloperDetailComponent, canActivate: [Authorized] },
  { path: 'providerLogoPriorities',      component:ProviderLogoPriorityComponent,canActivate: [Authorized] },
  { path: 'vademecum',      component:MedicinesComponent,canActivate: [Authorized] },
  { path: 'specialties',      component:SpecialtiesComponent, canActivate: [Authorized] },
  { path: 'specialty/:id',      component:SpecialtyComponent, canActivate: [Authorized] },
  { path: 'specialtyProviderConfig/:providerId/specialty/:specialtyId',      component:SpecialtyProviderConfigComponent, canActivate: [Authorized] },
  { path: 'healthInsuranceProviders',      component:HealthInsurancesComponent, canActivate: [Authorized] },
  { path: 'callTags',      component:CallTagsComponent, canActivate: [Authorized] },
  { path: 'patientValidation',      component:PatientValidationComponent, canActivate: [Authorized] },
  { path: 'failedEmail',      component:FailedEmailComponent, canActivate: [Authorized] },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes), NgbModule ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts